import React from 'react';
import { Content, SkillsContainer, SkillsData, SkillsHeader, SkillsList, SkillsSection, SkillsSubtitle, SkillsTitle,SkillsName, Subtitle, Title, MainSkillTitle, SkillsNumber, SkillsBar, SkillsPercentage } from './SkillsStyles';
import { UilBracketsCurly, UilAngleDown, UilAngleRight, UilServerNetwork } from '@iconscout/react-unicons';
import { useState } from 'react';

function Skills() {
    const [openFrontend, setOpenFrontend] = useState(true);
    const [openBackend, setOpenBackend] = useState(true);

    const toggleFront = ()=>{
        setOpenFrontend(!openFrontend);
    }
    const toggleBack = ()=>{
        setOpenBackend(!openBackend);
    }

    return (
        <SkillsSection className="skills-section">
            <Title>Skills</Title>
            <Subtitle>My technical level</Subtitle>

            <SkillsContainer>
                
                    {/* ======skills 1====== */}
                    <Content>
                        <SkillsHeader onClick={toggleFront}>
                            <UilBracketsCurly className="skills__icon" size="2rem"/>
                            <div>
                                <SkillsTitle>
                                    Frontend developer
                                </SkillsTitle>
                                <SkillsSubtitle>More than 1 year</SkillsSubtitle>
                            </div>
                            {openFrontend?<UilAngleDown className="skills__arrow front" size="2rem"/>:<UilAngleRight className="skills__arrow front" size="2rem"/>}
                        </SkillsHeader>
                        <SkillsList className="frontend" open={openFrontend}>
                            <SkillsData>
                                <MainSkillTitle>
                                    <SkillsName>HTML</SkillsName>
                                    <SkillsNumber>90%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={90} className="skill__html"></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>

                            <SkillsData>
                                <MainSkillTitle >
                                    <SkillsName>CSS</SkillsName>
                                    <SkillsNumber>80%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={80} className="skill__css"></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>            

                            <SkillsData>
                                <MainSkillTitle >
                                    <SkillsName>Javascript</SkillsName>
                                    <SkillsNumber>85%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={85} className="skill__js"></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>

                            <SkillsData>
                                <MainSkillTitle >
                                    <SkillsName>React js</SkillsName>
                                    <SkillsNumber>80%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={80} className="skill__react"></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>

                            <SkillsData>
                                <MainSkillTitle >
                                    <SkillsName>Styled-Components</SkillsName>
                                    <SkillsNumber>95%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={95} className="skill__styled"></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>
                        </SkillsList>
                    </Content>

                    {/* ======skills 2====== */}
                    <Content >
                        <SkillsHeader onClick={toggleBack}>
                            <UilServerNetwork className="skills__icon" size="2rem"/>

                            <div>
                                <SkillsTitle>
                                    Backend developer
                                </SkillsTitle>
                                <SkillsSubtitle>More than 1 year</SkillsSubtitle>
                            </div>
                            {openBackend?<UilAngleDown className="skills__arrow back" size="2rem"/>:<UilAngleRight className="skills__arrow back" size="2rem"/>}
                            
                        </SkillsHeader>
                        <SkillsList className="backend" open={openBackend}>
                            <SkillsData>
                                <MainSkillTitle>
                                    <SkillsName>Node js</SkillsName>
                                    <SkillsNumber>87%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={87} ></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>

                            <SkillsData>
                                <MainSkillTitle>
                                    <SkillsName>Express js</SkillsName>
                                    <SkillsNumber>85%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={85} ></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>

                            <SkillsData>
                                <MainSkillTitle>
                                    <SkillsName>Mongo DB</SkillsName>
                                    <SkillsNumber>70%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={70} ></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>

                            <SkillsData>
                                <MainSkillTitle>
                                    <SkillsName>Socket io</SkillsName>
                                    <SkillsNumber>60%</SkillsNumber>
                                </MainSkillTitle>
                                <SkillsBar>
                                    <SkillsPercentage width={60}></SkillsPercentage>
                                </SkillsBar>
                            </SkillsData>

                        </SkillsList>
                    </Content>
            

            </SkillsContainer>
        </SkillsSection>
    )
}

export default Skills